import { render, staticRenderFns } from "./SignInFormWhyRegister.vue?vue&type=template&id=05e4ca54&scoped=true&"
import script from "./SignInFormWhyRegister.vue?vue&type=script&lang=ts&"
export * from "./SignInFormWhyRegister.vue?vue&type=script&lang=ts&"
import style0 from "./SignInFormWhyRegister.vue?vue&type=style&index=0&id=05e4ca54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4ca54",
  null
  
)

export default component.exports